const fragment = `
  id
  imageUrl
  isDefault
`;

export const listCityImagesQuery = `
  query ListCityImages(
    $filter: CityImageFilterInput
  ) {
    items: listCityImages(filter: $filter) {
      ${fragment}
    }
  }
`;

export const createCityImageQuery = `
  mutation CreateCityImage(
    $input: CreateCityImageInput!
    $image: Upload
  ) {
    item: createCityImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateCityImageQuery = `
  mutation UpdateCityImage(
    $input: UpdateCityImageInput!
    $image: Upload
  ) {
    item: updateCityImage(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteCityImageQuery = `
  mutation DeleteCityImage(
    $id: Int!
  ) {
    item: deleteCityImage(id: $id) {
      ${fragment}
    }
  }
`;

export const sortCityImagesQuery = `
  mutation SortCityImages(
    $cityId: Int!,
    $ids: [Int!]!
  ) {
    items: sortCityImages(cityId: $cityId, ids: $ids) {
      id
    }
  }
`;
